export const getLatestResultForSample = (muestra) => {
  if (!Array.isArray(muestra?.resultados) || muestra.resultados.length === 0) {
    return null;
  }

  return muestra.resultados[muestra.resultados.length - 1];
};

export const createBatchEntryFromSample = (muestra) => {
  const latestResult = getLatestResultForSample(muestra);

  return {
    tipo_analisis: latestResult?.tipo_analisis || '',
    resultado_texto: latestResult?.resultado_texto || '',
    archivo_resultado: null,
  };
};

export const normalizeBatchEntryValue = (value) => (value || '').trim();
export const hasBatchEntryAttachment = (entry) => Boolean(entry?.archivo_resultado);

const isBatchEntryComplete = (entry) =>
  Boolean(normalizeBatchEntryValue(entry?.tipo_analisis) && normalizeBatchEntryValue(entry?.resultado_texto));

export const shouldSaveBatchEntry = (muestra, entry) => {
  if (!isBatchEntryComplete(entry)) {
    return false;
  }

  const initialEntry = createBatchEntryFromSample(muestra);

  return (
    hasBatchEntryAttachment(entry)
    || normalizeBatchEntryValue(entry?.tipo_analisis) !== normalizeBatchEntryValue(initialEntry.tipo_analisis)
    || normalizeBatchEntryValue(entry?.resultado_texto) !== normalizeBatchEntryValue(initialEntry.resultado_texto)
  );
};
